import React, { createContext, useContext, useState, ReactNode } from 'react';

interface PanelPositionContextType {
  isPanelOnRight: boolean;
  togglePanelPosition: () => void;
}

const PanelPositionContext = createContext<PanelPositionContextType | undefined>(undefined);

interface PanelPositionProviderProps {
  children: ReactNode;
}

export const PanelPositionProvider: React.FC<PanelPositionProviderProps> = ({ children }) => {
  const [isPanelOnRight, setIsPanelOnRight] = useState(false);

  const togglePanelPosition = () => {
    setIsPanelOnRight(prev => !prev);
  };

  return (
    <PanelPositionContext.Provider value={{ isPanelOnRight, togglePanelPosition }}>
      {children}
    </PanelPositionContext.Provider>
  );
};

export const usePanelPosition = (): PanelPositionContextType => {
  const context = useContext(PanelPositionContext);
  if (context === undefined) {
    throw new Error('usePanelPosition must be used within a PanelPositionProvider');
  }
  return context;
};
